export const QA_NAME_EMAIL_PROFILE_ACTIONS_WIDGET_NAVIGATION_RAIL_PREVIOUS =
  'emailProfileNavigationRailPrevious'

export const QA_NAME_EMAIL_PROFILE_ACTIONS_WIDGET_NAVIGATION_RAIL_NEXT =
  'emailProfileNavigationRailNext'
